































import {Component, Prop, Vue} from 'vue-property-decorator';
import {sortBy} from 'lodash';
import {BadgeStore, ILocalBadge} from '@/store/modules/badge.store';
import {TicketStore} from '@/store/modules/ticket.store';
import SingleBadge from '@/components/SingleBadge.vue';

@Component({
	components: {
		'single-badge': SingleBadge
	}
})
export default class BadgePicker extends Vue {
	showOverlayWrapper = false;

	@Prop({required: true})
	ticketId!: string;


	get ticket() {
		return TicketStore.byId(this.ticketId);
	}

	get badges() {
		return BadgeStore.sortedByName.map((badge) => {
			const foundTicket = TicketStore.ticketByBadgeId(badge.badgeId);
			const localBadge: ILocalBadge = {
				name: badge.name,
				badgeId: badge.badgeId,
				ticketId: null,
				state: 'UNASSIGNED',
				placeholder: false
			};
			if(foundTicket) {
				localBadge.ticketId = foundTicket.ticketId;
				localBadge.state = foundTicket.state;
			}
			return localBadge;
		}).filter((badge) => {
			return badge.state === 'UNASSIGNED';
		});
	}

	close() {
		this.showOverlayWrapper = false;
	}

	selectBadge(badge: ILocalBadge) {
		this.$emit('badgeSelected', badge.badgeId);
		this.close();
	}

	finalClose() {
		this.$emit('close');
	}
}
